/**
 * Design System Implementation
 *
 * Provides centralized access to typography, colors, and configuration.
 */

import * as Typography from "../configs/typography";
import * as Colors from "../configs/colors";
import { APP_CONFIG } from "../configs/config";

export const designSystem = {
  typography: {
    getPrimaryHeading: (type) => Typography.getPrimaryHeading(type),
    getSupportingText: (type, centered = false) =>
      Typography.getSupportingText(type, centered),
    getButtonStyles: () => Typography.BUTTON_TEXT,
    getUIStyles: () => Typography.UI_TEXT,
  },
  colors: {
    getInnovationTextClasses: () => Colors.getInnovationTextClasses(),
    getHighlightColor: (type = "default") => Colors.getHighlightColor(type),
    standardizeHighlightColors: (content) =>
      Colors.standardizeHighlightColors(content),
  },
  config: {
    getAppConfig: () => APP_CONFIG,
    getConfigValue: (key, defaultValue = null) =>
      APP_CONFIG?.[key] || defaultValue,
  },
};
